
import React from 'react';
import { Button } from '@/components/ui/button';
import { BookOpen, DollarSign } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface AuthorActionsProps {
  authorId: string;
}

const AuthorActions: React.FC<AuthorActionsProps> = ({ authorId }) => {
  const navigate = useNavigate();

  return (
    <div className="pt-4 flex flex-col gap-2">
      <Button 
        onClick={() => navigate(`/admin/authors/${authorId}/books`)}
        className="w-full"
      >
        <BookOpen className="h-4 w-4 mr-2" />
        Manage Books
      </Button>
      <Button 
        onClick={() => navigate(`/admin/authors/${authorId}/royalties`)}
        className="w-full"
      >
        <DollarSign className="h-4 w-4 mr-2" />
        View Royalties
      </Button>
    </div>
  );
};

export default AuthorActions;
